import { Flex, Image, Text, Center } from "@chakra-ui/react"
import { ICarNumberTypes } from "./CarNumberBoxTypes"
import GEO from "assets/country_flags/georgia.png"

const CarNumberBox: React.FC<ICarNumberTypes> = ({
  title,
  medium,
  withInput = false,
  width,
  height
}) => {

  return (
    <>
      {withInput ? (
        <Flex h="60px" w="200px">
          <Flex
            backgroundColor={"primary"}
            alignItems="center"
            width={"34px"}
            borderTopLeftRadius="8px"
            borderBottomLeftRadius="8px"
            flexDirection={"column"}
            justifyContent={"space-around"}
          >
            <Image src={GEO} alt="Flag" w={"18px"} h={"11px"} />
            <Text lineHeight={"12px"} fontSize={"12px"} color={"white"}>
              GE
            </Text>
          </Flex>
          <Center
            borderRadius="5px"
            borderLeft="unset"
            borderTopLeftRadius="unset"
            borderBottomLeftRadius="unset"
            borderColor="primary"
            borderWidth="1px"
            w="164px"
            fontSize="xxxl"
          >
            {title}
          </Center>
        </Flex>
      ) : (
        <Flex
          w={width}
          h={height}
          borderRadius={"5px"}
          flexDirection="row"
          borderColor={"primary"}
          borderWidth="2px"
        >
          <Flex
            backgroundColor={"primary"}
            alignItems="center"
            width={"16%"}
            borderTopLeftRadius="2px"
            borderBottomLeftRadius="2px"
            flexDirection={"column"}
            justifyContent={"space-around"}
          >
            <Image
              src={GEO}
              alt="Flag"
              w={medium ? "12px" : "11px"}
              h={medium ? "7px" : "7px"}
            />
            <Text
              lineHeight={"5px"}
              fontSize={medium ? "8px" : "7px"}
              color={"white"}
            >
              GE
            </Text>
          </Flex>
          <Flex align={"center"} justifyContent="center" width={"90%"} backgroundColor={"white"} borderTopRightRadius="5px" borderBottomRightRadius="5px">
            <Text fontSize={medium ? "16px" : " 13px"} lineHeight="12px" fontWeight="bold">
              {title}
            </Text>
          </Flex>
        </Flex>
      )}
    </>
  )
}

export default CarNumberBox
